import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { useParams, useHistory } from 'react-router-dom';
import cs from './index.module.scss';
import { Image } from 'antd';
import LogoIcon from '@/components/icons/LogoIcon';
import logoDark from '@/assets/logo/logo@2x.png';
import { useStore } from '@/models';
import { getExchangeUrl, isFromMobile } from "@/utils/location";

const Header: React.FC = () => {
  const { ui } = useStore();
  const { theme } = ui;
  const { push } = useHistory();

  return (
    <a
      onClick={() => {
        if (!isFromMobile()) {
          push('/');
        }else{
          push('/home');
        }
      }}
      className={cx(cs.logoWrap)}
    >
      {<Image width={88}  src={logoDark} preview={false}/>}
    </a>
  );
};

export default observer(Header);
